import React from 'react';
import SvgAudio from './Audio';
import SvgVideo from './Video';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaTypeIcon = ({
  mediaType,
  ...props
}) => mediaType === 'AUDIO' ? /*#__PURE__*/_jsx(SvgAudio, {
  ...props
}) : /*#__PURE__*/_jsx(SvgVideo, {
  ...props
});